import { render, staticRenderFns } from "./AdminMenuAdd.form.vue?vue&type=template&id=6c4ea01d&"
import script from "./AdminMenuAdd.form.vue?vue&type=script&lang=js&"
export * from "./AdminMenuAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports